<script lang="ts">
    import { onMount } from "svelte"

    let { contentSnippet, query, altSnippet }: { contentSnippet: () => any; query: string; altSnippet?: () => any } =
        $props()
    let mql: MediaQueryList
    let mqlListener: {
        (v: any): any
        (this: MediaQueryList, ev: MediaQueryListEvent): any
        (this: MediaQueryList, ev: MediaQueryListEvent): any
    }
    let wasMounted = false
    let matches = $state(false)
    const isSSR = typeof window === "undefined"

    onMount(() => {
        wasMounted = true
        return () => {
            removeActiveListener()
        }
    })

    $effect(() => {
        if (wasMounted) {
            removeActiveListener()
            addNewListener(query)
        }
    })

    function addNewListener(query: string) {
        if (!query) {
            query = "(min-width:0px)"
            console.warn(
                "Missing view property 'meta.views.mediaQuery' in collection config. Query has been set to '(min-width:0px)'."
            )
        }
        if (typeof window == "undefined") return
        mql = window.matchMedia(query)
        mqlListener = (e: { matches: boolean }) => (matches = e.matches)
        mql.addEventListener("change", mqlListener)
        matches = mql.matches
    }

    function removeActiveListener() {
        if (mql && mqlListener) {
            mql.removeEventListener("change", mqlListener)
        }
    }
</script>

{#if isSSR || matches}
    {@render contentSnippet()}
{:else if altSnippet}
    {@render altSnippet()}
{/if}
